module.exports = __webpack_public_path__ + "static/img/5797.f215dba7.png";